<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import MinimalTable from "./MinimalTable.svelte";
  import GlobalHotKey from "../common/GlobalHotKey.svelte";

  export let currentItemIndex: number | undefined;
  export let rowElements: HTMLDivElement[];

  $: rowCount = rowElements.length;

  const dispatch = createEventDispatcher<{
    setNextItem: number;
  }>();

  function handleHotkey(direction: "up" | "down") {
    if (!rowCount || currentItemIndex === undefined) {
      return;
    }

    const nextIndex =
      direction === "up" ? currentItemIndex - 1 : currentItemIndex + 1;

    if (nextIndex < 0 || nextIndex >= rowCount) {
      return;
    }

    dispatch("setNextItem", nextIndex);

    const selectedElement = rowElements[nextIndex];

    if (!selectedElement) {
      return;
    }

    selectedElement.scrollIntoView({
      block: "nearest",
      behavior: "instant",
    });
  }
</script>

<GlobalHotKey
  hotKey="ArrowUp"
  ctrlOrCmd={false}
  on:hotkey={() => handleHotkey("up")}
/>
<GlobalHotKey
  hotKey="ArrowDown"
  ctrlOrCmd={false}
  on:hotkey={() => handleHotkey("down")}
/>

<div class="overflow-x-auto">
  <MinimalTable>
    <slot />
  </MinimalTable>
</div>
